<script setup lang="ts">
import PartnerServicePreviewList from './PartnerServicePreviewList.vue';
import { type FragmentType, graphql } from '@/gql';
import { SpoilerTransition } from '@glow/shared/components/transitions';

const partnerServiceFragment = graphql(/* GraphQL */ `
  fragment PartnerGroupedServicePreview_PartnerServiceFragment on PartnerService {
    id
    ...PartnerServicePreviewList_PartnerServiceFragment
  }
`);

const props = defineProps<{
  title: string;
  services: FragmentType<typeof partnerServiceFragment>[];
}>();

const services = useFragmentArrayData(
  partnerServiceFragment,
  () => props.services
);

const isExpanded = ref(true);
</script>

<template>
  <div class="page-card py-4 py-sm-6">
    <div
      class="d-flex justify-content-between align-items-center gap-2 px-4 px-sm-6 mb-5"
    >
      <h2 class="m-0">
        {{ props.title }}
        <span class="text-black-tertiary">{{ services.length }}</span>
      </h2>
      <AppButton variant="link" @click="isExpanded = !isExpanded">
        {{ isExpanded ? 'Скрыть' : 'Показать' }}
      </AppButton>
    </div>
    <SpoilerTransition>
      <PartnerServicePreviewList
        v-show="isExpanded"
        can-be-liked
        :services="services"
      />
    </SpoilerTransition>
  </div>
</template>
